import React, { useEffect, useState } from 'react'
import { ValSpecialCharacters } from '../../../Validators/ValSpecialCharacters';
import { FormHelperText, InputAdornment, MenuItem, TextField } from '@mui/material';
import { ValOnlyNumber } from '../../../Validators/ValOnlyNumber';
import AccountBalanceIcon from "@mui/icons-material/AttachMoney";
import { Moneda } from '../../../Helpers/Moneda';
import PercentIcon from "@mui/icons-material/Percent";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Swal from 'sweetalert2';
import { FormatMoney } from '../../../Helpers/FormatNumber';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';
import { ValPedidoCondiciones } from '../../Dashboard/Clientes/CapturasDashClientes/PedidoMaquinaria/Validators/ValPedidoCondiciones';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const ReestructurarCreditoCondicionesTab = ({ folio }) => {
    const [activeField, setActiveField] = useState(null);

    const [condiciones, setCondiciones] = useState({
        condiciones: "",
        observaciones: "",
        deposito: "",
        tasa: "",
        anticipo: "",
        plazo: "",
        tiempo_plazo: "",
        mhusajdf: "",
        gastos: 0,
        enganche: 0,
        bcondiciones: "",
        bobservaciones: "",
        bdeposito: "",
        btasa: "",
        banticipo: "",
        bplazo: "",
        btiempo_plazo: false,
        bmhusajdf: "",
        bgastos: "",
        benganche: "",
        tipo_tasa: "",
        tipo_esquema: "",
        moneda: "",
        monto: 0,
        fechaPagare: ""
    });

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    console.log(folio)

    const onChanged = (prop, value, sbool, smensaje) => {
        setCondiciones({
            ...condiciones,
            [prop]: value,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setCondiciones({
            ...condiciones,
            [prop]: sinComas,
            ["b" + prop]: false,
            ["m" + prop]: "",
        });
    };

    useEffect(() => {
        if (folio !== null && folio !== undefined && folio !== "") {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ReestructurarCredito/ListadoCondiciones?folio=${folio}`)
                .then((result) => {
                    // console.log(result)

                    setCondiciones({
                        ...condiciones,
                        condiciones: result.condiciones.condiciones,
                        observaciones: result.condiciones.observaciones,
                        deposito: result.condiciones.deposito,
                        tasa:
                            result.condiciones.taza !== undefined &&
                                result.condiciones.taza !== null &&
                                result.condiciones.taza !== 0
                                ? result.condiciones.taza
                                : result.interes.interes,
                        mhusajdf: result.condiciones.mhusajdf,
                        anticipo: result.condiciones.anticipo,
                        monto: result.monto,
                        moneda:
                            result.condiciones.moneda !== undefined &&
                                result.condiciones.moneda !== null &&
                                result.condiciones.moneda !== ""
                                ? result.condiciones.moneda
                                : "MXN",
                        // gastos: result.gastos,
                        plazo: result.condiciones.plazo,
                        tiempo_plazo: result.condiciones.tiempo_plazo,
                        // enganche: result.enganche,
                        tipo_tasa: result.condiciones.tipo_tasa,
                        tipo_esquema: result.condiciones.tipo_esquema,
                        fechaPagare: result.condiciones.fecha_pagare
                    });
                    // setIntereses({
                    //     ...intereses,
                    //     interes: result.interes.interes,
                    //     interes2: result.interes.interes2
                    // })
                    var deposito = document.getElementById("deposito");
                    if (deposito !== undefined && deposito !== null)
                        deposito.value = FormatMoney(result.condiciones.deposito);
                    var tiempo_plazo = document.getElementById("tiempo_plazo");
                    if (tiempo_plazo !== undefined && tiempo_plazo !== null) {
                        tiempo_plazo.value = FormatMoney(result.condiciones.tiempo_plazo);
                    }
                    var tasa = document.getElementById("tasa");
                    if (tasa !== undefined && tasa !== null && result.condiciones.taza === 0)
                        tasa.value = FormatMoney(result.interes.interes)
                    else (
                        tasa.value = FormatMoney(result.condiciones.taza)
                    )

                    var anticipo = document.getElementById("anticipo");
                    if (anticipo !== undefined && anticipo !== null)
                        anticipo.value = FormatMoney(result.condiciones.anticipo);

                    var monto = document.getElementById("monto");
                    if (monto !== undefined && monto !== null)
                        monto.value = FormatMoney(result.condiciones.monto);
                    setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
                });
        }
    }, [folio]);

    const onGuardar = () => {
        setLoader({ ...loader, mostrar: true });
        var result = ValPedidoCondiciones(condiciones);

        if (result.isValid === false) {
            setLoader({ ...loader, mostrar: false });
            Swal.fire(
                "PEDIDO DE MAQUINARIA",
                JSON.stringify(result.mensaje),
                "error"
            );
        } else if (
            condiciones.moneda === "" ||
            condiciones.moneda === undefined ||
            condiciones.moneda === null
        ) {
            Swal.fire({
                title: "PEDIDO DE MAQUINARIA",
                text: "Seleccione una moneda",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            setLoader({ ...loader, mostrar: false });
        } else if (
            condiciones.monto === "" ||
            condiciones.monto === undefined ||
            condiciones.monto === null
        ) {
            Swal.fire({
                title: "PEDIDO DE MAQUINARIA",
                text: "Introduzca el monto de la operación",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            setLoader({ ...loader, mostrar: false });
        } else if (
            condiciones.fechaPagare === "" ||
            condiciones.fechaPagare === undefined ||
            condiciones.fechaPagare === null
        ) {
            Swal.fire({
                title: "PEDIDO DE MAQUINARIA",
                text: "Seleccione la fecha del pagare",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            setLoader({ ...loader, mostrar: false });
        }
        else {
            result.post.folio = folio;
            result.post.taza = condiciones.tasa;
            result.post.mhusajdf = "MHUSA";
            result.post.moneda = condiciones.moneda;
            result.post.monto = condiciones.monto
            result.post.fecha_pagare = condiciones.fechaPagare

            request
                .post("ReestructurarCredito/GuardarCondiciones", result.post)
                .then(async () => {
                    setLoader({ ...loader, mostrar: false });
                    await Swal.fire(
                        "PEDIDO DE MAQUINARIA",
                        "Datos guardados con exito",
                        "success"
                    );
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
                });
        }
    };

    const handleTextFieldFocus = (fieldName) => {
        setActiveField(fieldName); // Marcar el TextField como activo cuando se enfoca
    };

    const handleTextFieldBlur = () => {
        setActiveField(null); // Desactivar el TextField cuando pierde el foco
    };

    return (
        <div className='container-total'>
            <div className='reestructurar-credito-condiciones-screen-container scroll-4'>
                <LoaderScreen loader={loader} />

                <div className="reestructurar-credito-condiciones-inputs-container">
                    <div className='reestructurar-credito-generales-container'>
                        <TextField
                            fullWidth
                            id="monto"
                            size="small"
                            label="Monto"
                            variant="outlined"
                            type="text"
                            // className="pr-5 cel-6"
                            inputProps={{
                                style: { textAlign: "right" },
                            }}
                            onChange={({ target }) => {
                                ValOnlyNumber("monto", target.value, onChange, true, 10);
                            }}
                            sx={{ mb: 2, width: 250 }}
                            onKeyUp={(input) => Moneda(input.target)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <AttachMoneyIcon size="small" />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <TextField
                            fullWidth
                            size="small"
                            label="Fecha de Pagare"
                            variant="outlined"
                            className="cel-1-1"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CalendarMonthIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                            }}
                            type="date"
                            onChange={({ target }) => {
                                setCondiciones({ ...condiciones, fechaPagare: target.value });
                            }}
                            value={condiciones.fechaPagare}
                            sx={{ width: 250 }}
                        ></TextField>
                    </div>

                    <TextField
                        fullWidth
                        size="small"
                        label="Condiciones para Operación de Venta"
                        className='reestructurar-credito-condiciones'
                        multiline
                        rows={2}
                        type="text"
                        error={condiciones.bcondiciones}
                        onChange={({ target }) => {
                            ValSpecialCharacters(
                                "condiciones",
                                target.value,
                                onChanged,
                                true,
                                500
                            );
                        }}
                        onFocus={() => handleTextFieldFocus("condiciones")} // Manejar el foco del TextField
                        onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
                        value={condiciones.condiciones}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"></InputAdornment>,
                        }}
                    />
                    {activeField === "condiciones" && (
                        <FormHelperText className="caracteres-especiales">
                            {"Puedes usar caracteres especiales como: $, #, . , y ñ."}
                        </FormHelperText>
                    )}
                </div>
                <div className="reestructurar-credito-observaciones">
                    <TextField
                        fullWidth
                        size="small"
                        label="Observaciones"
                        variant="outlined"
                        // className="cel-2"
                        multiline
                        rows={2}
                        type="text"
                        error={condiciones.bobservaciones}
                        onChange={({ target }) => {
                            ValSpecialCharacters(
                                "observaciones",
                                target.value,
                                onChanged,
                                true,
                                500
                            );
                        }}
                        onFocus={() => handleTextFieldFocus("observaciones")} // Manejar el foco del TextField
                        onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
                        value={condiciones.observaciones}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"></InputAdornment>,
                        }}
                    />
                    {activeField === "observaciones" && (
                        <FormHelperText className="caracteres-especiales">
                            {"Puedes usar caracteres especiales como: $, #, . , y ñ."}
                        </FormHelperText>
                    )}
                </div>
                <TextField
                    fullWidth
                    size="small"
                    label="Deposito Realizado"
                    variant="outlined"
                    className="cel-3"
                    type="text"
                    name="deposito"
                    id="deposito"
                    error={condiciones.bdeposito}
                    onKeyUp={(input) => Moneda(input.target)}
                    onChange={({ target }) => {
                        ValOnlyNumber("deposito", target.value, onChange, true, 10);
                    }}
                    value={condiciones.deposito}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <AccountBalanceIcon />
                            </InputAdornment>
                        ),
                    }}
                    inputProps={{
                        style: { textAlign: "right" },
                    }}
                />
                <div className="cel-4">
                    <TextField
                        fullWidth
                        size="small"
                        label="Anticipo Total"
                        variant="outlined"
                        // className="cel-4"
                        type="text"
                        error={condiciones.banticipo}
                        onChange={({ target }) => {
                            ValOnlyNumber("anticipo", target.value, onChange, true, 10);
                        }}
                        sx={{ paddingRight: "5px" }}
                        // onChange={({ target }) => {
                        //   setCondiciones({ ...condiciones, anticipo: target.value });
                        // }}
                        // value={condiciones.anticipo}
                        onKeyUp={(input) => Moneda(input.target)}
                        name="anticipo"
                        id="anticipo"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountBalanceIcon />
                                </InputAdornment>
                            ),
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />
                    <TextField
                        fullWidth
                        size="small"
                        label="Moneda"
                        variant="outlined"
                        // className="cel-11"
                        select
                        sx={{
                            "& .MuiInputBase-root": {
                                height: "35px", // Cambia el valor para ajustar la altura
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccountBalanceIcon fontSize="small" />
                                </InputAdornment>
                            ),
                        }}
                        type="text"
                        // error={condiciones.moneda}
                        // onChange={({ target }) => {
                        //     setCondiciones({ ...condiciones, moneda: target.value });
                        // }}
                        value={condiciones.moneda}
                    >
                        <MenuItem value={"MXN"}>PESOS</MenuItem>
                        <MenuItem value={"USD"}>DOLARES</MenuItem>
                    </TextField>
                </div>
                <div className="taza-actualizar-container">
                    <TextField
                        fullWidth
                        // disabled={state.tipo_solicitud === "C" ? true : true}
                        size="small"
                        label="Tasa Anual Aplicada"
                        variant="outlined"
                        className="cell-5"
                        type="text"
                        name="tasa"
                        id="tasa"
                        error={condiciones.btasa}
                        onKeyUp={(input) => Moneda(input.target)}
                        onChange={({ target }) => {
                            ValOnlyNumber("tasa", target.value, onChange, true, 8);
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <PercentIcon />
                                </InputAdornment>
                            ),
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                        }}
                    />
                    {/* <button
                    className="cell-6"
                    onClick={() => onActualizarInteres()}
                >
                    Actualizar
                </button> */}
                </div>
                <div className="cel-6">
                    <TextField
                        fullWidth
                        // disabled={state.tipo_solicitud === "C" ? true : false}
                        size="small"
                        label="Plazo"
                        variant="outlined"
                        select
                        type="text"
                        className="cel-plazo"
                        onChange={({ target }) => {
                            setCondiciones({ ...condiciones, plazo: target.value });
                        }}
                        value={condiciones.plazo}
                        sx={{
                            "& .MuiInputBase-root": {
                                height: "35px", // Cambia el valor para ajustar la altura
                            },
                        }}
                    >
                        <MenuItem value="dias">DIAS</MenuItem>
                        <MenuItem value="meses">MESES</MenuItem>
                        <MenuItem value="años">AÑOS</MenuItem>
                    </TextField>

                    <TextField
                        fullWidth
                        // disabled={state.tipo_solicitud === "C" ? true : false}
                        size="small"
                        label="Tiempo"
                        variant="outlined"
                        type="number"
                        error={condiciones.btiempo_plazo}
                        onChange={({ target }) => {
                            ValOnlyNumber("tiempo_plazo", target.value, onChange, true, 10);
                        }}
                        value={condiciones.tiempo_plazo}
                        // onFocus={onFocus}
                        // onBlur={onBlurCondiciones}
                        name="tiempo_plazo"
                        id="tiempo_plazo"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        }}
                        inputProps={{
                            style: { textAlign: "right" },
                            max: 10,
                        }}
                    />
                </div>
                <div className='reestructurar-credito-condiciones-boton-guardar-container'>
                    <div
                        onClick={() => onGuardar()}
                        className="reestructurar-credito-condiciones-boton-guardar"
                    >
                        {/* <SaveIcon />  */}
                        GUARDAR
                    </div>
                </div>
            </div>
        </div>
    )
}
